import { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { authActions } from "../../redux/store";
import toast from "react-hot-toast";
import TokenValidator from "../../fetchdata/TokenValidator";
import PropTypes from "prop-types"; // Import PropTypes
import { useBlogContext } from "../../fetchdata/BlogContext";
import getCookie from "../../helper/getCookie";
import eraseCookie from "../../helper/eraseCookie";

const SideBar = ({ isVisible, toggleSidebar }) => {

    const {
      Headers,
    } = useBlogContext();
   


  const [isLogin, setIsLogin] = useState(!!getCookie("token"));

  useEffect(() => {
    setIsLogin(!!getCookie("token"));
  }, [isVisible]);

    useEffect(() => {
       console.log("Headers", Headers);

  }, [Headers]);
 

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    try {
      dispatch(authActions.logout());
      toast.success("Logout Successfully");
      setIsLogin(false);
      toggleSidebar();
      navigate("/login");
      eraseCookie("token");
      localStorage.removeItem("token");
      localStorage.removeItem("userId");
      localStorage.removeItem("user");
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <TokenValidator />

      <div className={`sidebar ${isVisible && "show"}`}>
        <div className="sidebar-body">
          <div className="sidebar-header">
            <div className="app-logo d-none">
              {/* <img
                className="logo-dark"
                src="assets/images/app-logo/logo.png"
                alt="logo"
              /> */}
            </div>
            <div className="title-bar mb-0">
              <h4 className="title font-w600">Main Menus</h4>
              <button
                className="menu-close border-0 bg-transparent"
                onClick={toggleSidebar}
              >
                <i className="ri-close-line"></i>
              </button>
            </div>
          </div> 
        
        <ul className="nav navbar-nav">
  {Headers?.header?.map((item) => (
    <li key={item.id}>
      <NavLink
        className="nav-link"
        to={item.link}
        target={item.target || "_self"}
        onClick={toggleSidebar}
      >
          <span>{item.text}</span>
      
      
      </NavLink>

      {/* If children exist (nested menu) */}
      {item.children && item.children.length > 0 && (
        <ul className="submenu">
          {item.children.map((child) => (
            <li key={child.id}>
              <NavLink
                className="nav-link"
                to={child.link}
                target={child.target || "_self"}
              >
                <span>{child.text}</span>
              </NavLink>
            </li>
          ))}
        </ul>
      )}
    </li>
  ))}
  {isLogin && (
    <li>
      <button
        type="button"
        className="nav-link border-0 bg-transparent w-100 text-start"
        onClick={handleLogout}
      >
        <span>Logout</span>
      </button>
    </li>
  )}
</ul>


        </div>
      </div>


    </>
  );
};

SideBar.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  toggleSidebar: PropTypes.func.isRequired,
};

// ToggleButton component as a named export
export const ToggleButton = ({ onClick }) => (
  <button
    type="button"
    className="icon dz-floating-toggler border-0 bg-transparent "
    onClick={onClick} style={{ width: 30, height: 30 }}

  >
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="#04764E"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y={2} width={20} height={3} rx="1.5" fill="#04764E" />
      <rect y={18} width={20} height={3} rx="1.5" fill="#04764E" />
      <rect x={4} y={10} width={20} height={3} rx="1.5" fill="#04764E" />
    </svg>
  </button>
);


ToggleButton.propTypes = {
  onClick: PropTypes.func.isRequired, // Corrected PropTypes for onClick function
};


export default SideBar;
